import React from 'react';
import '../svg.css';


const ConfFurniture = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="confFurniture-1" width="36" height="36" rx="10" /></g><polygon className="confFurniture-2" points="12.17 17.22 12.74 27.58 23.26 27.58 23.83 17.22 12.17 17.22" /><rect className="confFurniture-2" x="11.4" y="29.05" width="13.2" height="1.47" /><path className="confFurniture-2" d="M12.13,9.6l1.76-.87a1.87,1.87,0,0,0,1.18.42,1.84,1.84,0,1,0-1.84-1.83.28.28,0,0,0,0,.09L10.67,8.7v2.65h1.46Z" /><path className="confFurniture-2" d="M25.33,8.7,22.76,7.41a.28.28,0,0,0,0-.09,1.84,1.84,0,1,0-1.84,1.83,1.87,1.87,0,0,0,1.18-.42l1.76.87v1.75h1.46Z" /><rect className="confFurniture-3" x="9.2" y="12.82" width="17.6" height="2.93" />


        </svg>
    );
};

export default ConfFurniture;
